var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDiagonal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.6 40.6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M36.6 0h-28v4h25.1L0 37.7l2.8 2.9L36.6 6.8V32h4V0z"
  })));
}

export default SvgArrowDiagonal;